/**
 * Uma sparkline: a forma de uma série ao longo do tempo, do tamanho de uma linha de texto.
 *
 * Serve para «o valor da carteira mês a mês» ao lado do número atual — a forma responde «está
 * subindo ou caindo?» sem ocupar uma seção inteira.
 *
 * SVG aqui, e não `<div>`s, porque uma linha diagonal em HTML é uma gambiarra. Mas continua sem
 * eixo, sem grade e sem tooltip: **o primeiro e o último valor vão no DOM, em texto**, e é isso
 * que a sparkline promete responder. Quem quiser os valores do meio abre a lista de posições.
 */
import { COR_PRINCIPAL } from './escalas';

export function Miniserie({
  valores,
  rotuloInicio,
  rotuloFim,
  largura = 96,
  altura = 24,
}: {
  valores: number[];
  rotuloInicio?: string;
  rotuloFim?: string;
  largura?: number;
  altura?: number;
}) {
  // Menos de dois pontos não é uma série: é um número, e um número se escreve.
  if (valores.length < 2) return null;

  const min = Math.min(...valores);
  const max = Math.max(...valores);
  const amplitude = max - min || 1;
  const passo = largura / (valores.length - 1);
  const pontos = valores
    .map((v, i) => {
      // 2px de folga em cima e embaixo: sem isso, o máximo e o mínimo encostam na borda e a linha
      // parece cortada.
      const y = altura - 2 - ((v - min) / amplitude) * (altura - 4);
      return `${(i * passo).toFixed(1)},${y.toFixed(1)}`;
    })
    .join(' ');

  return (
    <span className="inline-flex items-center gap-2">
      {rotuloInicio && (
        <span className="tipo-corpo-pequeno text-text-tertiary">{rotuloInicio}</span>
      )}
      <svg
        width={largura}
        height={altura}
        viewBox={`0 0 ${largura} ${altura}`}
        aria-hidden="true"
        className="shrink-0"
      >
        <polyline
          points={pontos}
          fill="none"
          stroke={COR_PRINCIPAL}
          strokeWidth={1.5}
          strokeLinejoin="round"
          strokeLinecap="round"
        />
      </svg>
      {rotuloFim && <span className="tipo-dado text-text">{rotuloFim}</span>}
    </span>
  );
}
